if (document.querySelector(".map")) {
    ymaps.ready(init);
    let myMap, myPlacemark;

    function init() {
        myMap = new ymaps.Map("footerMap", {
                center: [43.450811, 39.938532],
                zoom: 16,
                controls: ['geolocationControl', 'zoomControl', 'fullscreenControl'],
            }
        );

        myPlacemark = new ymaps.Placemark([43.450811, 39.938532], {
            balloonContent: `<p><b>г.Сочи, Аэропорт, ул. Мира 183/4</b></p><p>Тел.: +7(862)279-46-17</p>`
        }, {
            iconLayout: 'default#image',
            // Своё изображение иконки метки.
            iconImageHref: '/themes/sales/assets/images/icons/location-red.svg',
            // Размеры метки.
            iconImageSize: [25, 34],
            // Смещение левого верхнего угла иконки относительно
            // её "ножки" (точки привязки).
            iconImageOffset: [-25, -30]
        });
        myMap.geoObjects.add(myPlacemark);
    }
}
